<template>
  <v-col cols="6" lg="7" md="8">
    <v-alert
      dense
      outlined
      text
      border="left"
      class="mb-2"
      elevation="1"
      type="info"
    >
      <span>Report excludes Order Queries & Credit Returns</span>
    </v-alert>
  </v-col>
</template>

<script>
export default {
  props: {},

  components: {},

  data: () => ({}),

  methods: {}
}
</script>

<style lang="scss" scoped></style>
